@if (jsonText) {
    <div>
        <div class="justify-center">
            <div
                class="custom-border max-w-[85%] overflow-auto mx-auto mt-4 whitespace-pre-wrap">
                {{ jsonText }}
            </div>
        </div>
    </div>
} @else {
    <apcam-loading-spinner centered class="my-4" />
}
